import React from "react";
import Routes from "./Routes";
import { BrowserRouter as Router } from "react-router-dom";

function App() {
  return (
    <Router basename="/Payment">
      <Routes />
    </Router>
  );
}

export default App;
